import React from "react";
import classes from "./DenOverview.module.css";
import { useTranslation } from 'react-i18next';
import ItemDrops from "../EventViewer/Event/ItemDrops";
import Icon from "../../components/UI/Icon/Icon";
import AbilityNames from "../EventViewer/Event/AbilityNames";
import {maxRank, minRank} from "../../Util/NestUtil"

function range(start, end) {
    return [...Array(end-start+1).keys()].map(i => i + start);
}

const MonDetailLight = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);
    
    return (
        <div className={classes.Entry}>
            <div className={classes.Center}><Icon details={props.data} /></div>
            <p><strong>{t("RARITY")}: </strong></p>
            <ul>
                {props.data.Probabilities.map((i, idx) => {
                    return i > 0 ? <li key={idx}>{"☆".repeat(idx+1)}: {i}%</li> : null
                })}
            </ul>
            <p><strong>{t("FLAWLESSIVS")}:</strong> {props.data.FlawlessIVs}</p>
            <p><strong>{t("ABILITY")}:</strong></p><AbilityNames species={props.data.Species} altForm={props.data.AltForm} ability={props.data.Ability} />
            {
                range(minRank(props.data), maxRank(props.data)).map(lvl => <ItemDrops key={lvl} level={lvl} index={lvl} bonus={props.data.BonusTableID} drops={props.data.DropTableID} bonusTables={props.bonus} dropTables={props.drops} />
                )
                
            }
        </div>
        );
};

export default MonDetailLight;